import React from "react";
import { Upload, Button, message, Tooltip } from "antd";
import { VideoCameraOutlined } from "@ant-design/icons";
import ApiUserUploads from "../../api/user-uploads";

const MAX_VIDEO_SIZE = 20 * 1024 * 1024 * 1024; // 20GB
const ALLOWED_VIDEO_MIME = /^(video\/mp4|video\/quicktime)$/i;

const VideoUpload = ({
  articleId,
  legalDocumentId,
  disabled = false,
  onInsertVideo, // ({src, uploadId, poster?})
  dailyTaskId,
  onInsertHtml,  // optional
}) => {
  const uploadVideo = async (file) => {
    if (!articleId && !legalDocumentId && !dailyTaskId) {
      message.error("No target specified");
      return Upload.LIST_IGNORE;
    }

    if (!ALLOWED_VIDEO_MIME.test(file.type)) {
      message.error("Only MP4 or MOV videos (h264) are supported");
      return Upload.LIST_IGNORE;
    }

    if (file.size > MAX_VIDEO_SIZE) {
      message.error("Unable to load file as its size exceeds the limit of 20GB");
      return Upload.LIST_IGNORE;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);
      if (articleId) formData.append("articleId", articleId);
      if (legalDocumentId) formData.append("legalDocumentId", legalDocumentId);
      if (dailyTaskId) formData.append("dailyTaskId", dailyTaskId);

      const response = await ApiUserUploads.uploadVideo(formData);

      const signedUrl = response?.data?.signedUrl;
      const uploadId = response?.data?.userUpload?.id;

      if (!signedUrl || !uploadId) throw new Error("Invalid upload response");

      if (onInsertVideo) {
        onInsertVideo({ src: signedUrl, uploadId });
      } else if (onInsertHtml) {
        onInsertHtml(
          `<video src="${signedUrl}" controls style="max-width:100%;height:auto;" id="${uploadId}" data-id="${uploadId}"></video>`
        );
      }
    } catch (err) {
      console.error("❌ Video upload failed:", err);
      message.error("Video upload failed");
    }

    return Upload.LIST_IGNORE;
  };

  return (
    <Tooltip title="Upload video">
      <Upload
        accept="video/mp4,video/quicktime"
        beforeUpload={uploadVideo}
        showUploadList={false}
        disabled={disabled}
      >
        <Button
          type="text"
          className="lf-editor__iconbtn"
          icon={<VideoCameraOutlined />}
          disabled={disabled}
        />
      </Upload>
    </Tooltip>
  );
};

export default VideoUpload;